import { connect } from 'react-redux';
import {
  getIsHotelOnly,
  getCustomCashbackIconUrl,
  getActivateCashbackForPartner,
  getCashbackLabel,
  getCashbackTooltip,
  getIsWebview,
  getCurrencyCode,
  getIsMobile,
} from 'src/store/view/selectors';
import { fetchHotelImagesAction } from 'src/store/hotelImages/sagaActions';
import { hotelImagesByIdSelector } from 'src/store/hotelImages/selectors';

import { getIsAdmin } from 'src/store/client/selectors';
import {
  getTouristsCount,
  getDestinationCountryName,
  getSearchDestinationTitle,
  getRequestId,
  isFlexDatesSelector,
} from '../../selectors/searchParams';
import { getOfferFilters } from '../../selectors/filters';
import { makeGetIsViewed } from '../../selectors/viewedHotels';

import { hotelClickedAction } from '../../actions/hotels';
import { resetPopupData } from '../../store/map/slice';
import HotelRenderer from './HotelRenderer';

const getIsViewed = makeGetIsViewed();

const mapStateToProps = (state, { hotelInfo, defaultImages, index = 0 }) => {
  const { hotel } = hotelInfo;
  const { id: hotelId } = hotel;

  return {
    hotelInfo,
    hotelId,
    hotel,
    isPreloadable: index <= 1,
    customCashbackIconURL: getCustomCashbackIconUrl(state),
    customCashbackText: getCashbackLabel(state),
    customCashbackTooltipText: getCashbackTooltip(state),
    activateCashbackForPartner: getActivateCashbackForPartner(state),
    imagesList: hotelImagesByIdSelector(state, hotelId) || defaultImages,
    requestId: getRequestId(state),
    // TODO: Проверить, работает ли getIsViewed и используется ли hotelId в нем
    // @ts-ignore
    isViewed: getIsViewed(state, hotelId),
    isMobile: getIsMobile(state),
    country: getDestinationCountryName(state),
    destinationTitle: getSearchDestinationTitle(state),
    touristsCount: getTouristsCount(state),
    offerFilters: getOfferFilters(state),
    isAdmin: getIsAdmin(state),
    isHotelOnly: getIsHotelOnly(state),
    isFlexDates: isFlexDatesSelector(state),
    isWebview: getIsWebview(state),
    currencyCode: getCurrencyCode(state),
  };
};

const mapDispatchToProps = {
  getImages: fetchHotelImagesAction,
  hotelClicked: hotelClickedAction,
  resetPopupDataHandler: resetPopupData,
};

export default connect(mapStateToProps, mapDispatchToProps)(HotelRenderer);
